import useSearchParams from '@/hooks/useSearchParams'
import { setDelistingSession } from '@/stores/delisting'
import { getSessionStorage, setSessionStorage } from '@/utils'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

export const DELISTING_ACC_NO = 'acc'
export const DELISTING_RECOMMANDED_FUND = 'fund'
export const DELISTING_AGENT_CODE = 'agentcode'

const InitSearchParams = () => {
  const { searchParams, removeSearchParams } = useSearchParams()
  const dispatch = useDispatch()

  useEffect(() => {
    const accountNo = searchParams.get(DELISTING_ACC_NO)
    const recommendedFundCode = searchParams.get(DELISTING_RECOMMANDED_FUND)
    const agentCode = searchParams.get(DELISTING_AGENT_CODE)

    if (!!accountNo && !!recommendedFundCode && !!agentCode) {
      // decodeAndManageToken(delistingRefNo)
      dispatch(
        setDelistingSession({
          accountNo,
          recommendedFundCode,
          agentCode,
        })
      )
      setSessionStorage(DELISTING_ACC_NO, accountNo)
      setSessionStorage(DELISTING_RECOMMANDED_FUND, recommendedFundCode)
      setSessionStorage(DELISTING_AGENT_CODE, agentCode)
      removeSearchParams()
    } else {
      const sessionStorageAccNo = getSessionStorage(DELISTING_ACC_NO)
      const sessionStorageRecommendedFund = getSessionStorage(
        DELISTING_RECOMMANDED_FUND
      )
      const sessionAgentCode = getSessionStorage(DELISTING_AGENT_CODE)
      !!sessionStorageAccNo &&
        !!sessionStorageRecommendedFund &&
        dispatch(
          setDelistingSession({
            accountNo: sessionStorageAccNo,
            recommendedFundCode: sessionStorageRecommendedFund,
            agentCode: sessionAgentCode,
          })
        )
      /* !!sessionStorage &&
        decodeAndManageToken(getSessionStorage(DELISTING_REF_NO)) */
    }
  }, [])

  return null
}

export default InitSearchParams
